export default __webpack_public_path__ + "1.18.21/static/media/libreView-small.22d31a32.svg";